import { Grid, Typography } from '@mui/material'
import { PrintTotalPrice } from './PrintTotalPrice'
import { IDiscountDetailLine, ItemDetailAndPriceProps } from './interface'
import MonetaryFormat from '../MonetaryFormat'
import LocalOffer from '@mui/icons-material/LocalOffer'
import { useCustomerFacingDisplayContext } from 'pages/CustomerFacingDisplayPage/context/CustomerFacingDisplayProvider'

export function DiscountDetailLine({
    name,
    discountAmount,
    reason,
}: IDiscountDetailLine) {
    const {
        operationalSetting: { currencyCode, language },
    } = useCustomerFacingDisplayContext()

    return (
        <Grid container direction={'row'} justifyContent="space-between">
            <Grid item>
                <Grid pt={1} container spacing={1} direction={'row'}>
                    <Grid item justifySelf={'center'}>
                        <LocalOffer fontSize="small" color="primary" />
                    </Grid>
                    <Grid item justifySelf={'center'}>
                        <Typography color={'primary'}>{name}</Typography>
                        {reason && (
                            <Typography
                                pb={1}
                                fontSize={14}
                                color={'textSecondary'}
                            >
                                {reason}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <MonetaryFormat
                    component="span"
                    value={discountAmount * -1}
                    currencyCode={currencyCode ?? 'USD'}
                    language={language ?? 'en'}
                />
            </Grid>
        </Grid>
    )
}
export function ItemDetailAndPrice({
    itemName,
    ...props
}: ItemDetailAndPriceProps) {
    return (
        <Grid container direction={'row'} justifyContent="space-between">
            <Grid item>
                <Typography>{itemName}</Typography>
            </Grid>
            <Grid item>
                <PrintTotalPrice {...props} />
            </Grid>
        </Grid>
    )
}
